import React, { FC, useCallback, useState, ChangeEvent } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Modal,
  Stack,
  TextField,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface IProps {
  isOpen: boolean;
  setIsOpen(val: boolean): void;
  onProductAdd(name: string, description: string, slug: string): void;
}

const AddInfoPage: FC<IProps> = ({ isOpen, setIsOpen, onProductAdd }) => {
  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [slug, setSlug] = useState<string>('');

  const handleModalClose = useCallback(() => {
    setName('');
    setDescription('');
    setSlug('');
    setIsOpen(false);
  }, []);

  const handleProductAdd = useCallback(() => {
    onProductAdd(name, description, slug);
    setName('');
    setDescription('');
    setSlug('');
    setIsOpen(false);
  }, [name, description, slug, onProductAdd]);

  const onNameChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setName(event.currentTarget.value);
    },
    []
  );

  const onDescriptionChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setDescription(event.currentTarget.value);
    },
    []
  );

  const onSlugChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setSlug(event.currentTarget.value);
    },
    []
  );

  return (
    <Modal open={isOpen} onClose={handleModalClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          color: 'text.primary',
          p: 1
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={handleModalClose}>
            <CloseIcon
              sx={(theme) => ({
                '&:hover': {
                  color: theme.palette.error.main
                }
              })}
            />
          </IconButton>
        </Box>
        <Box sx={{ p: 3, pt: 0 }}>
          <Typography variant="h6">Добавление инфостраницы</Typography>
          <TextField
            fullWidth
            multiline
            error={!name}
            value={name}
            onChange={onNameChange}
            label="Название"
            helperText={!name && 'Введите название инфостраницы'}
            variant="filled"
            sx={{ mt: '15px' }}
          />
          <TextField
            fullWidth
            multiline
            error={!description}
            value={description}
            onChange={onDescriptionChange}
            label="Описание"
            helperText={!description && 'Введите описание'}
            variant="filled"
            sx={{ mt: '15px' }}
          />
          <TextField
            fullWidth
            multiline
            error={!slug}
            value={slug}
            onChange={onSlugChange}
            label="Слаг"
            helperText={!slug && 'Введите навзание в ссылке'}
            variant="filled"
            sx={{ mt: '15px' }}
          />
          <Stack
            flexDirection="row"
            gap={2}
            sx={{ pt: 5, justifyContent: 'flex-end' }}
          >
            <Button
              size="small"
              variant="outlined"
              color="success"
              disabled={!name}
              onClick={handleProductAdd}
            >
              Добавить
            </Button>
            <Button size="small" variant="outlined" onClick={handleModalClose}>
              Отменить
            </Button>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddInfoPage;
